/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.11",
    versionName: "0.2.0-nightly.2026.3.11",
    versionChannel: "nightly",
    buildDate: "2026-03-11T00:09:48.185Z",
    commitHash: "79371ec537c708bad0e4b75b3fe49cecabc29745",
};
